import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

const Err404 = () => {
  return (
    <section id="err404">
      <div className="err-body">

        <p className="err-monogram">L &amp; M</p>
        <div className="err-rule" />

        <h1 className="err-code">404</h1>

        <div className="err-rule err-rule--short" />

        <p className="err-title">Página no encontrada</p>
        <p className="err-desc">
          La página que buscas no existe o fue movida.<br />
          Regresa al inicio y sigue celebrando con nosotros.
        </p>

        <Link to="/" className="err-btn">
          Volver al inicio
        </Link>

        <p className="err-date">19 · Septiembre · 2026</p>

      </div>
    </section>
  );
};

export default Err404;
